import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './Pages/Home'
import Portfolio from './Pages/Portfolio'
const App = () => {
  return (
    <>
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/Portfolio" element={<Portfolio/>}/>
      </Routes>
      </BrowserRouter>
    </>
  )
}

export default App

